module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[83]82.d9085a1.woff2";